module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp3_7042.c0707006.png";